// import http from './http';
import CrudApi from './crud';

export const crud = new CrudApi('/admin/featuredachievements');
